import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { I18n } from 'common/i18n';
import GuidanceSummaryV2PropType from 'common/propTypes/GuidanceSummaryV2PropType';

import { ManageViewersActionItem } from './action_items/ManageViewersActionItem';
import { EditMetadataActionItem } from './action_items/EditMetadataActionItem';
import { ManageCollaboratorsActionItem } from './action_items/ManageCollaboratorsActionItem';
import { TransferOwnershipActionItem } from './action_items/TransferOwnershipActionItem';
import { DeleteAssetActionItem } from './action_items/DeleteAssetActionItem';
import { LockAssetActionItem } from './action_items/LockAssetActionItem';
import { WithdrawFromApprovalActionItem } from './action_items/WithdrawFromApprovalActionItem';
import { ToggleCatalogVisibility } from './action_items/ToggleCatalogVisibility';
import { GoToSourceActionItem } from './action_items/GoToSourceActionItem';
import { ManageFederationsActionItem } from './action_items/ManageFederationsActionItem';

class ActionItemList extends Component {
  static propTypes = {
    approvalsGuidance: GuidanceSummaryV2PropType,
    assetIsStoryDraft: PropTypes.bool,
    assetType: PropTypes.string.isRequired,
    closeCurrentModal: PropTypes.func.isRequired,
    // null means asset is not a revision
    revisionInfo: PropTypes.object,
    setCurrentModal: PropTypes.func.isRequired,
    updateAudience: PropTypes.func,
    transferOwnership: PropTypes.func,
    view: PropTypes.object,
  };

  render() {
    // list of all action items
    const actionItems = [
      GoToSourceActionItem,
      EditMetadataActionItem,
      ManageViewersActionItem,
      ManageCollaboratorsActionItem,
      ManageFederationsActionItem,
      ToggleCatalogVisibility,
      TransferOwnershipActionItem,
      LockAssetActionItem,
      DeleteAssetActionItem,
      WithdrawFromApprovalActionItem,
    ];

    // TODO: The above list is never actually filtered, so this is never true
    if (actionItems.length === 0) {
      return (
        <div className="no-actions-possible">
          {I18n.t('shared.asset_browser.result_list_table.action_dropdown.no_actions_possible')}
        </div>
      );
    }

    return (
      <div className="action-dropdown-menu">
        {actionItems.map((ActionItem) => (
          <ActionItem {...this.props} key={ActionItem} />
        ))}
      </div>
    );
  }
}

export default ActionItemList;
